@if (contentEdit) {
  <p style="margin-bottom: 20px">Just a line.</p>
}
<rendered-gmm-line [item]="item"></rendered-gmm-line>

@if (contentEdit && item) {
  <coin-v2-checkbox
    class="spacing-elements"
    [label]="'Full Width'"
    [(ngModel)]="item.fullWidth" />
  @if (showBackgroundPicker) {
    <div class="spacing-elements">
      <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
    </div>
  }
}
